/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BusinessCategoryV2,
    BusinessCategoryV2FromJSON,
    BusinessCategoryV2FromJSONTyped,
    BusinessCategoryV2ToJSON,
} from './BusinessCategoryV2';
import {
    GetBusinessCategoriesLv2ResponseAllOf,
    GetBusinessCategoriesLv2ResponseAllOfFromJSON,
    GetBusinessCategoriesLv2ResponseAllOfFromJSONTyped,
    GetBusinessCategoriesLv2ResponseAllOfToJSON,
} from './GetBusinessCategoriesLv2ResponseAllOf';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 
 * @export
 * @interface GetBusinessCategoriesLv2Response
 */
export interface GetBusinessCategoriesLv2Response {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetBusinessCategoriesLv2Response
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetBusinessCategoriesLv2Response
     */
    message: string;
    /**
     * 
     * @type {Array<BusinessCategoryV2>}
     * @memberof GetBusinessCategoriesLv2Response
     */
    data: Array<BusinessCategoryV2>;
}

export function GetBusinessCategoriesLv2ResponseFromJSON(json: any): GetBusinessCategoriesLv2Response {
    return GetBusinessCategoriesLv2ResponseFromJSONTyped(json, false);
}

export function GetBusinessCategoriesLv2ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBusinessCategoriesLv2Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(BusinessCategoryV2FromJSON)),
    };
}

export function GetBusinessCategoriesLv2ResponseToJSON(value?: GetBusinessCategoriesLv2Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(BusinessCategoryV2ToJSON)),
    };
}

